import { render } from "./LoginRootCaptchaEsp.vue?vue&type=template&id=5c803338"
import script from "./LoginRootCaptchaEsp.vue?vue&type=script&lang=js"
export * from "./LoginRootCaptchaEsp.vue?vue&type=script&lang=js"

import "./LoginRootCaptchaEsp.vue?vue&type=style&index=0&id=5c803338&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__